import { createApp } from 'vue';
import App from './App.vue';
import './styles/app.css'; // Here
import router from './router'
import Particles from "particles.vue3";
import 'aos/dist/aos.css'

createApp(App).use(router).use(Particles).mount('#app');
